import React, { useEffect, useState, useCallback } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import TextBox from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchRounded from '@material-ui/icons/SearchRounded';
import { UnityInputFieldProps } from './UnityInputField.types';

import './UnityInputField.scss';

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: '500px',

		'& > *': {
			borderRadius: '8px',
		},
	},
	postPeRegular400: {
		fontFamily: 'PoppinsRegular',
		fontSize: '15px',
		lineHeight: '19px',
		color: '#FFCD1E',
	},
}));

const UnityInputField: React.FC<UnityInputFieldProps> = ({
	className,
	fieldType,
	labelTruncateLength = 0,
	startAdornment,
	endAdornment,
	error,
	helperText,
	inputType,
	inputMode,
	onInputChange,
	value,
	regex,
	onChange,
	label,
	placeholder,
	...others
}) => {
	const classes = useStyles();
	const [validInput, setValidInput] = useState(true);
	const [labelValue, setLabelValue] = useState('');
	const [placeholderValue, setPlaceholderValue] = useState('');

	useEffect(() => {
		if (label && typeof label === 'string') {
			const labelVal = label.length > labelTruncateLength ? label.substr(0, labelTruncateLength).concat('...') : label;
			setLabelValue(labelVal);
		}
	}, [label, labelTruncateLength]);

	useEffect(() => {
		if (placeholder && typeof placeholder === 'string') {
			const placeholderVal =
				placeholder.length > labelTruncateLength
					? placeholder.substr(0, labelTruncateLength).concat('...')
					: placeholder;
			setPlaceholderValue(placeholderVal);
		}
	}, [placeholder, labelTruncateLength]);

	const onChangeEvent = (event: any) => {
		if (typeof onChange === 'function') {
			onChange(event);
		}

		if (typeof onInputChange === 'function') {
			onInputChange(event, validInput);
		}
	};

	useEffect(() => {
		setValidInput(!error);
	}, [error]);

	if (fieldType === 'search') {
		//delete others['label'];

		return (
			<TextBox
				{...others}
				variant="outlined"
				placeholder="Search here"
				className={clsx(classes.root, className)}
				InputProps={{
					...others?.InputProps,
					endAdornment: (
						<InputAdornment position="end">
							<SearchRounded color="primary" />
						</InputAdornment>
					),
				}}
				inputProps={{
					...others?.inputProps,
					inputMode,
				}}
				error={!validInput}
				helperText={validInput ? '' : helperText}
				value={value}
				label={labelValue || label}
				onChange={onChangeEvent}
			/>
		);
	}

	return (
		<div className="flex flex-column">
			<span className={`mb1 ${classes.postPeRegular400}`}>{label}</span>
			<TextBox
				{...others}
				variant="standard"
				className={clsx(classes.root, className)}
				InputProps={{
					...others?.InputProps,
					startAdornment: startAdornment ? <InputAdornment position="start">{startAdornment}</InputAdornment> : null,
					endAdornment: endAdornment ? <InputAdornment position="end">{endAdornment}</InputAdornment> : null,
				}}
				inputProps={{
					...others?.inputProps,
					inputMode,
				}}
				error={!validInput}
				helperText={validInput ? '' : helperText}
				value={value}
				onChange={onChangeEvent}
				//label={labelValue || label}
				placeholder={placeholderValue || placeholder}
			/>
		</div>
	);
};

UnityInputField.defaultProps = {
	color: 'primary',
	fieldType: 'default',
	startAdornment: null,
	endAdornment: null,
	helperText: 'Field Required',
	labelTruncateLength: 30,
};

export default UnityInputField;
